import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getsubsection } from "../../actions/subsectionAction";
import { getcandidate } from "../../actions/candidateAction";
import { FaSearch, FaMapMarkerAlt, FaChevronRight, FaChartPie } from "react-icons/fa";
import "./AdminDashboard.css"; 

// -----------------------------
// Marathi Name Formatting
// -----------------------------
const formatNameToMarathi = (name) => {
    if (!name) return "";
    const lower = name.toLowerCase();
    const m = lower.match(/(\d+)/);
    if (m) return `प्रभाग क्रमांक ${m[1]}`;
    return name;
};

const AdminDashboard = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [searchTerm, setSearchTerm] = useState("");

    // ------------------- SUBSECTION REDUX -------------------
    const subsectionState = useSelector((state) => state.subsection || {});
    const { subsection = [], loading = false, error = null } = subsectionState;

    // ------------------- CANDIDATE REDUX --------------------
    const candidateStateA = useSelector((state) =>
        state.candidate?.getcandidate ? state.candidate.getcandidate : null
    );
    const candidateStateB = useSelector((state) => state.getcandidateList || null);
    const candidateStateC = useSelector((state) =>
        state.candidate?.list ? state.candidate.list : null
    );

    const allCandidates = candidateStateA || candidateStateB || candidateStateC || [];

    // ------------------- FETCH DATA -------------------------
    useEffect(() => {
        dispatch(getsubsection());
        dispatch(getcandidate());
    }, [dispatch]);

    // ------------------- SEARCH FILTER ----------------------
    const filteredSubsections = subsection.filter((item) => {
        const mar = formatNameToMarathi(item.name || "");
        const q = searchTerm.toLowerCase();
        return item.name.toLowerCase().includes(q) || mar.toLowerCase().includes(q);
    });

    return (
        <div className="admin-dashboard-container">

            {/* ---------------- HEADER ---------------- */}
            <div className="dashboard-header">
                <div className="header-content">

                    {/* Left Side - Title */}
                    <div className="header-title-section">
                        <div className="logo-icon">
                            <FaChartPie />
                        </div>
                        <div>
                            <h1 className="page-title">अ‍ॅडमिन डॅशबोर्ड</h1>
                            <p className="page-subtitle">निवडणूक प्रभाग आणि उमेदवार व्यवस्थापन</p>
                        </div>
                    </div>

                    {/* Right Side - Stats + Search */}
                    <div className="header-actions">

                        {/* Total Subsections */}
                        <div className="stat-badge">
                            <span>एकूण प्रभाग:</span>
                            <strong>{subsection.length}</strong>
                        </div>

                        {/* Search Box */}
                        <div className="search-box">
                            <FaSearch className="search-icon" />
                            <input
                                type="text"
                                placeholder="प्रभाग शोधा..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>

                    </div>
                </div>
            </div>

            {/* ------------------- CONTENT ------------------- */}
            <div className="dashboard-content">

                {/* LOADING */}
                {loading && (
                    <div className="empty-state">
                        <p>लोड होत आहे...</p>
                    </div>
                )}

                {/* ERROR */}
                {error && (
                    <div className="empty-state">
                        <p className="text-danger">त्रुटी: {String(error)}</p>
                    </div>
                )}

                {/* DATA */}
                {!loading && !error && (
                    <>
                        {filteredSubsections.length > 0 ? (

                            <div className="cards-grid">
                                {filteredSubsections.map((item, index) => {
                                    const marathiName = formatNameToMarathi(item.name);

                                    const candidateCount = allCandidates.filter(
                                        (c) => String(c.subsectionId) === String(item.id)
                                    ).length;

                                    return (
                                        <div
                                            key={index}
                                            className="ward-card"
                                            onClick={() => navigate(`/view-candidate/${item.id}`)}
                                        >
                                            <div className="card-left">
                                                <div className="icon-box">
                                                    <span className="ward-initial">
                                                        {marathiName.charAt(0)}
                                                    </span>
                                                </div>

                                                <div className="card-info">
                                                    <span className="card-label">प्रभाग क्रमांक / नाव</span>
                                                    <h3 className="card-title">{marathiName}</h3>

                                                    <p className="candidate-count">
                                                        उमेदवार: <strong>{candidateCount}</strong>
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="card-right">
                                                <button className="action-btn">
                                                    <FaChevronRight />
                                                </button>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                        ) : (

                            <div className="empty-state">
                                <FaMapMarkerAlt size={50} color="#ccc" />
                                <p>कोणतीही प्रभाग माहिती आढळली नाही.</p>
                            </div>

                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default AdminDashboard;
